export default {
  header: 'Pridať hodnotiaci test',
  description: 'Vyberte typ hodnotenia, ktorý chcete pridať, kliknutím na jedno z tlačidiel.',
  createTable: 'Tabuľka',
  createChart: 'Graf',
  createImage: 'Obrázok',
  createFile: 'Súbor',
};
